// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"37c82e93","551":"d52c3c75","842":"8eea4e61"}[chunkId] + ".chunk.js";
};